// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.softlite-number-control-inline>div>div{
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
}
.softlite-number-control-inline>div>div div:nth-child(1){
    width: 40%;
}
.softlite-number-control-inline>div>div div:nth-child(3){
    width: 59%;
}
.softlite-number-control-inline.rotate{
    margin-bottom: 19px;
}
.softlite-number-control-inline label, .softlite-toggle-control-icon span.components-base-control__label{
    font-size: 13px !important;
    text-transform: capitalize !important;
    font-weight: 400 !important;
}
.softlite-toggle-control-icon{
    margin-bottom: 20px;
    margin-top: 13px;
}`, "",{"version":3,"sources":["webpack://./assets/js/src/controls/icon/icon.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;AACA;IACI,0BAA0B;IAC1B,qCAAqC;IACrC,2BAA2B;AAC/B;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB","sourcesContent":[".softlite-number-control-inline>div>div{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    flex-direction: row;\r\n}\r\n.softlite-number-control-inline>div>div div:nth-child(1){\r\n    width: 40%;\r\n}\r\n.softlite-number-control-inline>div>div div:nth-child(3){\r\n    width: 59%;\r\n}\r\n.softlite-number-control-inline.rotate{\r\n    margin-bottom: 19px;\r\n}\r\n.softlite-number-control-inline label, .softlite-toggle-control-icon span.components-base-control__label{\r\n    font-size: 13px !important;\r\n    text-transform: capitalize !important;\r\n    font-weight: 400 !important;\r\n}\r\n.softlite-toggle-control-icon{\r\n    margin-bottom: 20px;\r\n    margin-top: 13px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
